import {combineReducers} from 'redux';
import userData from './userDataReducer';
import merchantData from './merchantDataReducer';
import statements from './statementsReducer';
import accountRepData from './accountRepDataReducer';

const rootReducer = combineReducers({
  userData,
  merchantData,
  statements,
  accountRepData
});

export default rootReducer;
